<template>
    <div class="animated fadeIn">
        <b-card-body>
            <b-row>
                <b-col align="right">
                    <b-button type="button" variant="success"  @click='onCreateCompany()'><i class="fa fa-add"></i> Создать компанию</b-button>
                    <br><br>
                </b-col>
            </b-row>
        </b-card-body>

        <div class="row">
            <b-col md="6">

                <b-form-group label="Тип компании: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                    <b-form-select
                        id="basicSelect"
                        @change="applyTypeFilter()"
                        :plain="true"
                        v-model="typeFilter"
                        :options="CONSTANTS.COMPANY_TYPES"
                        value="Please select">
                    </b-form-select>
                </b-form-group>
            </b-col>
        </div>

        <v-server-table :url="apiurl('company/table')"  :columns="columns" :options="options" :theme="theme" id="companiesTable" ref="companiesTable" class="table" >
            <a href="#" slot="m_disabled" slot-scope="props" @click.prevent="disable(props.row, !!props.row.m_disabled)"  >
                <i class="cui-lightbulb text-secondary fa-lg" v-if="!!props.row.m_disabled"></i>
                <i class="cui-lightbulb text-warning fa-lg" v-if="!props.row.m_disabled"></i>
            </a>
            <router-link :to="{ path: '/admin/company/'+props.row.id }" slot="cmd_edit" slot-scope="props" >
                <i class="fa fa-edit fa-lg text-primary"></i>
            </router-link>
            <span slot="type" slot-scope="props">
                {{ CONSTANTS.COMPANY_TYPES[props.row.type] }}
            </span>
        </v-server-table>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import {CONSTANTS} from '@/constants';

    Vue.use(ServerTable)

    export default {
        name: 'AdminCompanies',
        components: { ServerTable, Event },
        mixins: [functions, functions_loaders, functions_company],
        data: function () {
            return {
                filterDisabled:null,
                columns:[ 'id', 'title', 'type', 'inn', 'phones', 'm_disabled', 'cmd_edit'],
                options:{

                    sortable: ['id', 'title', 'm_disabled'],
                    filterable: ['id', 'title', 'phones', 'inn'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 10, edge: false, nav: 'scroll', dropdown:false },
                    perPage:20,
                    perPageValues:[],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    columnsClasses: {
                        m_disabled: "center",
                        cmd_edit: "center",
                    },
                    customFilters: [
                        'type'
                    ],
                    initFilters: {
                        type:this.$store.state.companyFilters.typeFilter,
                    },
                    headings: {
                        id: '#',
                        title: 'наименование компании',
                        phones: 'телефоны',
                        inn: 'ИНН',
                        type: 'тип',
                        cmd_edit: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование компании"></i>
                        ) },
                        m_disabled: function(h) { return (
                            <i class="cui-lightbulb fa-lg" title="включение/отключение компании"></i>
                        ) },
                    },
                    saveState: true,
                },
                theme: 'bootstrap4',
                template: 'default',
                typeFilter:CONSTANTS.COMPANY_TYPE_AGENCY,
            }
        },
        methods: {
            disable: function(company, state) {
                if (state) {
                    this.enableCompany(company.id, function() {
                        company.m_disabled = 0;
                    })
                }
                else {
                    this.disableCompany(company.id, function() {
                        company.m_disabled = 1;
                    })
                }
            },
            onCreateCompany: function() {
                this.createCompany(function (self) {
                    //self.$refs.companiesTable.refresh();
                    self.$router.push({ path: '/admin/company/'+self.company.id});
                }, this);
            },

            saveFilter: function() {
                console.log('saveFilter');
                this.$store.commit('saveCompanyFilters', {
                    typeFilter:this.typeFilter,
                });
            },

            restoreFilter: function() {
                console.log('restoreFilter');
                this.typeFilter = this.$store.state.companyFilters.typeFilter;
                if (!this.typeFilter) this.typeFilter=CONSTANTS.COMPANY_TYPE_AGENCY;
            },

            applyTypeFilter: function () {
                this.saveFilter();
                Event.$emit('vue-tables.filter::type', this.typeFilter);
            }
        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.restoreFilter();
        }
    }
</script>
